var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 35,
    viewBox: "0 0 48 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5137 1V14.4444",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5699 3.44446H24.9865C24.4193 3.44446 23.8752 3.6698 23.4741 4.07092C23.073 4.47204 22.8477 5.01608 22.8477 5.58335C22.8477 6.15062 23.073 6.69465 23.4741 7.09577C23.8752 7.49689 24.4193 7.72224 24.9865 7.72224H28.0421C28.6094 7.72224 29.1534 7.94758 29.5545 8.3487C29.9556 8.74982 30.181 9.29386 30.181 9.86112C30.181 10.4284 29.9556 10.9724 29.5545 11.3735C29.1534 11.7747 28.6094 12 28.0421 12H22.8477",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3086 25.3846V20.4615M33.6178 26C33.6178 26 36.695 25.3846 41.6184 22.9231C46.5419 20.4615 49.1908 24.6088 44.6956 27.2308C39.7721 30.1026 30.7868 34 26.8481 34C22.9093 34 13.3086 26 13.3086 30.3077V30.7692C13.3086 31.8738 12.4132 32.7692 11.3086 32.7692H3C1.89543 32.7692 1 31.8738 1 30.7692V20C1 18.8954 1.89543 18 3 18H11.3086C12.4132 18 13.3086 18.8954 13.3086 20V20.4615M33.6178 26C33.6178 26 33.1255 28.4615 31.1561 28.4615C29.1867 28.4615 25.0018 28.4615 23.1555 28.4615M33.6178 26C33.823 24.9744 33.6178 22.9231 31.1561 22.9231C28.6944 22.9231 26.4378 22.9231 25.6172 22.9231C24.5915 22.1026 21.6785 20.4615 18.2321 20.4615C14.7856 20.4615 13.5138 20.4615 13.3086 20.4615",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRequests);
export default __webpack_public_path__ + "static/media/PaymentRequests.cdddd0b4cc4ce5ddbbb514c5bc01769c.svg";
export { ForwardRef as ReactComponent };